const relativeTime = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

const units = [
  { unit: 'year', seconds: 365 * 24 * 60 * 60 },
  { unit: 'month', seconds: 30.44 * 24 * 60 * 60 },
  { unit: 'week', seconds: 7 * 24 * 60 * 60 },
  { unit: 'day', seconds: 24 * 60 * 60 },
  { unit: 'hour', seconds: 60 * 60 },
  { unit: 'minute', seconds: 60 },
] as const;

export function timeAgo(date: Date | string): string {
  const value = date instanceof Date ? date : new Date(date);
  const differenceInSeconds = (value.getTime() - Date.now()) / 1000;

  if (!Number.isFinite(differenceInSeconds)) {
    return '';
  }

  const matchingUnit = units.find(({ seconds }) => Math.abs(differenceInSeconds) >= seconds);
  if (!matchingUnit) {
    return relativeTime.format(0, 'minute');
  }

  return relativeTime.format(
    Math.round(differenceInSeconds / matchingUnit.seconds),
    matchingUnit.unit
  );
}
